import { Collapse, Typography } from 'antd';
import React from 'react';
import { IOrderHeaderCardsProps } from './OrderHeaderCards.props';

const { Text } = Typography;

export const OrderHeaderCardsMobile: React.FC<IOrderHeaderCardsProps> = ({
  jobCard,
  customerCard,
  invoiceCard,
}) => (
  <Collapse
    bordered={false}
    defaultActiveKey={[]}
    style={{ background: '#fafcff', marginBottom: 8 }}
    items={[
      {
        key: 'job',
        label: <Text type="secondary" strong style={{ fontSize: 14 }}>Job card details</Text>,
        children: jobCard,
        style: { padding: 0 },
      },
      {
        key: 'customer',
        label: <Text type="secondary" strong style={{ fontSize: 14 }}>Customer & vehicle details</Text>,
        children: customerCard,
        style: { padding: 0 },
      },
      {
        key: 'invoice',
        label: <Text type="secondary" strong style={{ fontSize: 14 }}>Invoice details</Text>,
        children: invoiceCard,
        style: { padding: 0 },
      },
    ]}
  />
);
